
export { 
    createPostUrl, editPostUrl, postAudienceUrl,
    importDocumentUrl, circleUrl, postCircleUrl, 
    circleMembersUrl, postCircleId, postUrl,
    url4post
} from "lib-core"
